import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getCookie } from '../@core/utils/get-cookie.utils';
import { PreEmploymentActivitiesService } from '../services/pre-employment-activities.service';


@Injectable({
  providedIn: 'root',
})
export class PreEmploymentSelfserviceGuard implements CanActivate {
  loggedInStatus: boolean = false;

  constructor(
    private preEmploymentActivitiesService: PreEmploymentActivitiesService,
    private router: Router
  ) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    const token = getCookie('myesse_access_token');

    if (this.loggedInStatus) {
      return true;
    }

    const usedIdp = getCookie('active_idp');
    if (usedIdp === 'ias-white-oidc' || usedIdp === 'ias-blue-oidc') {
      localStorage.setItem('oidc-login', usedIdp);
    } else {
      return false;
    }

    this.loggedInStatus = await this.preEmploymentActivitiesService.validateToken(token!);

    if (!this.loggedInStatus) {
      this.router.navigate(['/auth/login']);
    }

    return this.loggedInStatus;
  }
}
